import { createApi } from '@reduxjs/toolkit/dist/query/react';

import {
  type TgConfirmRequest,
  type TgMessage,
  type TgSession,
  type TgSessionCreateRequest,
  type TgSessionPatchRequest,
} from '../types/TgSessionsTypes';
import { baseQuery, getBaseQueryWithReauth } from 'redux/baseQueryAuth';

export const TgSessionsApi = createApi({
  reducerPath: 'TgSessionsApi',
  tagTypes: ['TgSessions', 'TgMessages'],
  baseQuery: getBaseQueryWithReauth(baseQuery),
  endpoints: (build) => ({
    getTgSessions: build.query<TgSession[], void>({
      query: () => ({ url: '/trader/tg_accounts/', method: 'GET' }),
      providesTags: [{ type: 'TgSessions', id: 'LIST' }],
    }),
    createTgSession: build.mutation<TgSession, TgSessionCreateRequest>({
      query: (body) => ({ url: '/trader/tg_accounts/', method: 'POST', body }),
      invalidatesTags: [{ type: 'TgSessions', id: 'LIST' }],
    }),
    sendTgCode: build.mutation<TgSession, number>({
      query: (id) => ({ url: `/trader/tg_accounts/${id}/send_code/`, method: 'POST' }),
      invalidatesTags: [{ type: 'TgSessions', id: 'LIST' }],
    }),
    confirmTgLogin: build.mutation<TgSession, TgConfirmRequest>({
      query: ({ id, ...body }) => ({ url: `/trader/tg_accounts/${id}/confirm/`, method: 'POST', body }),
      invalidatesTags: [{ type: 'TgSessions', id: 'LIST' }],
    }),
    patchTgSession: build.mutation<TgSession, TgSessionPatchRequest>({
      query: ({ id, ...body }) => ({ url: `/trader/tg_accounts/${id}/`, method: 'PATCH', body }),
      invalidatesTags: [{ type: 'TgSessions', id: 'LIST' }],
    }),
    deleteTgSession: build.mutation<void, number>({
      query: (id) => ({ url: `/trader/tg_accounts/${id}/`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'TgSessions', id: 'LIST' }],
    }),
    getTgMessages: build.query<TgMessage[], number>({
      query: (id) => ({ url: `/trader/tg_accounts/${id}/messages/`, method: 'GET', params: { limit: 30 } }),
      providesTags: (_result, _error, id) => [{ type: 'TgMessages', id }],
    }),
  }),
});

export const {
  useGetTgSessionsQuery,
  useCreateTgSessionMutation,
  useSendTgCodeMutation,
  useConfirmTgLoginMutation,
  usePatchTgSessionMutation,
  useDeleteTgSessionMutation,
  useGetTgMessagesQuery,
} = TgSessionsApi;
